import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import CONFIG from '../../config';
import { useFirebaseCounter } from '../../hooks/useFirebaseCounter';

const URL = `${CONFIG.API_URL}/operarNotificaciones.php`;

function Notificaciones({ acceder, rol }) {
    const userId = localStorage.getItem('loggedUserId')
    const [notificacionesUsr, setNotificacionesUsr] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!acceder) {
            localStorage.clear();
            navigate('/');
        } else {
            buscaNotificaciones(userId)
        }
    }, [acceder]);

    const buscaNotificaciones = async (id) => {
        const data = {
            'id': id,
            'modo': 'todas las notificaciones'
        };
        try {
            const res = await axios.post(URL, data);
            console.log('Response from API noti:', res.data);
            if (!res.data.error) {
                setNotificacionesUsr(res.data.data);
                console.log('Notificaciones usuario:', res.data.notificar);
            } else {
                setNotificacionesUsr([]);
            }
        } catch (err) {
            if (err.response) {
                // Server responded with a status other than 2xx
                console.error('Server Error:', err.response.data);
            } else if (err.request) {
                // Request was made but no response received
                console.error('Network Error:', err.request);
            } else {
                // Something happened in setting up the request
                console.error('Error', err.message);
            }
            //show_alerta('Error en la solicitud', 'error');
        }
    };
    useFirebaseCounter(
        userId ? `notificaciones/user_${userId}` : null,
        () => {
            buscaNotificaciones(userId);
        }
    );
    return (
        <div className="container-principal">
            <h3 className='mx-4'>Notificaciones</h3>
            <div className='card shadow border-0 p-4 mx-4 mt-4' >
                <div className='d-flex '>
                    <button type='button' className='btn btn-success m-1'>Todas</button>
                    <button type='button' className='btn btn-outline-secondary m-1'>Mensajes</button>
                    <button type='button' className='btn btn-outline-secondary m-1'>En el curso</button>
                    <button type='button' className='btn btn-outline-secondary m-1'>Evento de hoy</button>
                </div>
            </div>
            <div className='card shadow border-0 p-1 mx-4 mt-2 mb-4 '>
                <div className='alert alert-info'>Aca aparecen todas las notificaciones de mensajes, eventos, etc. </div>
            </div>
        </div>
    );
}

export default Notificaciones;